import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { APP_INITIALIZER } from '@angular/core';

//import { NgbModule } from //'@ng-bootstrap/ng-bootstrap';

import { AccordionModule } from 'primeng/accordion';
//import { DataListModule } from 'primeng/datalist';
import { TabViewModule } from 'primeng/tabview';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
//import { SharedModule } from 'primeng/shared';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
//import { DataGridModule } from 'primeng/datagrid';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { TreeModule } from 'primeng/tree';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { ListboxModule } from 'primeng/listbox';
import { MenubarModule } from 'primeng/menubar';
import { ToastModule } from 'primeng/toast';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ColorPickerModule } from 'primeng/colorpicker';
import { DropdownModule } from 'primeng/dropdown';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { SharedModule } from 'primeng/api';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MessageService as PrimeMessageService } from 'primeng/api';

import { AppComponent } from './app.component';

import { AppConfig } from 'common';
import { UvExplorerClient as HttpClient } from 'common';

import { IdentityService } from 'identity';
import { UserPermissionsService } from 'identity';
import { LicensingWebService } from 'identity';
import { LicensingService } from 'identity';
import { ProfileComponent } from 'identity';
import { AccountComponent } from 'identity';
import { AccountEditorComponent } from 'identity';
import { PasswordDialogComponent } from 'identity';
import { UserListComponent } from 'identity';
import { UserComponent } from 'identity';
import { UserDialogComponent } from 'identity';
import { DirectoryUserComponent } from 'identity';
import { DirectoryUserDialogComponent } from 'identity';
import { ApiKeyListComponent } from 'identity';
import { ApiKeyComponent } from 'identity';
import { ApiKeyDialogComponent } from 'identity';
import { ActivationWizardComponent } from 'identity';
import { DeactivationWizardComponent } from 'identity';
import { UpdateLicenseWizardComponent } from 'identity';
import { LicenseManagerComponent } from 'identity';
import { LoginComponent } from 'identity';
import { AuthSettingsComponent } from 'identity';
import { AdAuthSettingsComponent } from 'identity';
import { AdAdminDialogComponent } from 'identity';
import { GwAuthSettingsComponent } from 'identity';
import { SamlAuthSettingsComponent } from 'identity';
import { GoogleAdminDialogComponent } from 'identity';
import { PrivacyPolicyComponent } from 'identity';
import { GroupListComponent } from 'identity';
import { GroupComponent } from 'identity';
import { GroupDialogComponent } from 'identity';
import { UserSelectorComponent } from 'identity';
import { GroupSelectorComponent } from 'identity';
import { UsersWebService } from 'identity';
import { UsersService } from 'identity';
import { ApiKeysWebService } from 'identity';
import { ApiKeysService } from 'identity';
import { DirectoryGroupComponent } from 'identity';
import { DirectoryGroupDialogComponent } from 'identity';
import { AdminComponent } from 'identity';
import { UserTypeInfoComponent } from 'identity';

import { MessageService } from 'base';
import { DateService } from 'base';
import { MessageComponent } from 'base';
import { InfoComponent } from 'base';
import { DeviceCategorySelectorComponent } from 'base';
import { StringSelectorComponent } from 'base';
import { ConfirmationDialogComponent } from 'base';
import { ScheduleComponent } from 'base';

import { CredentialsComponent } from 'credentials';
import { PrtgSettingsComponent } from 'credentials';
import { SnmpSettingsComponent } from 'credentials';
import { SnmpV3SettingsComponent } from 'credentials';
import { SshSettingsComponent } from 'credentials';
import { TelnetSettingsComponent } from 'credentials';
import { VimSettingsComponent } from 'credentials';
import { WindowsSettingsComponent } from 'credentials';
import { HttpSettingsComponent } from 'credentials';

import { SchedDiscConfigAdvancedComponent } from 'discovery';
import { SchedDiscConfigBasicComponent } from 'discovery';
import { SchedDiscConfigEventsComponent } from 'discovery';
import { SchedDiscConfigProtocolsComponent } from 'discovery';
import { SchedDiscConfigPrtgComponent } from 'discovery';
import { SchedDiscConfigAssetPandaComponent } from 'discovery';
import { SchedDiscConfigITGlueComponent } from 'discovery';
import { SchedDiscConfigHaloComponent } from 'discovery';
import { SchedDiscConfigHuduComponent } from 'discovery';
import { SchedDiscConfigJiraComponent } from 'discovery';
import { SchedDiscConfigScheduleComponent } from 'discovery';
import { SchedDiscConfigScopesComponent } from 'discovery';
import { SchedDiscStatusComponent } from 'discovery';
import { PrtgExportConfigComponent } from 'discovery';
import { AssetPandaExportConfigComponent } from 'discovery';
import { ITGlueExportConfigComponent } from 'discovery';
import { HaloExportConfigComponent } from 'discovery';
import { HuduExportConfigComponent } from 'discovery';
import { JiraExportConfigComponent } from 'discovery';
import { DiscResultsWebService } from 'discovery';
import { DiscResultsService } from 'discovery';

import { NetworkComponent } from 'netview';
import { NetworkListComponent } from 'netview';
import { AgentComponent } from 'netview';
import { AgentListComponent } from 'netview';
import { DiscoveryComponent } from 'netview';
import { DiscoveryListComponent } from 'netview';
import { DiscResultComponent } from 'netview';
import { DiscResultListComponent } from 'netview';
import { NetworkSettingsComponent } from 'netview';
import { AgentSettingsComponent } from 'netview';
import { DeviceFilterComponent } from 'netview';
import { DeviceFilterListComponent } from 'netview';
import { DeviceFilterSelectorComponent } from 'netview';
import { DeviceGroupComponent } from 'netview';
import { DeviceGroupEditorComponent } from 'netview';
import { DeviceGroupListComponent } from 'netview';
import { NewAgentDialogComponent } from 'netview';
import { NewNetworkDialogComponent } from 'netview';
import { NewDiscoveryDialogComponent } from 'netview';
import { NewUserLinkDialogComponent } from 'netview';
import { DeviceGroupDialogComponent } from 'netview';
import { NetworkDeactivateGuard } from 'netview';
import { DiscoveryDeactivateGuard } from 'netview';
import { AgentDeactivateGuard } from 'netview';
import { UserLinkListComponent } from 'netview';
import { MapSettingsComponent } from 'netview';
import { DevicesComponent } from 'netview';
import { DeviceListComponent } from 'netview';
import { DevicePreviewComponent } from 'netview';
import { DeviceSelectorComponent } from 'netview';
import { NvtnPrtgExportConfigComponent } from 'netview';
import { AgentClientComponent } from 'netview';
import { NetViewWebService } from 'netview';
import { NetViewService } from 'netview';
import { NetFacadeService } from 'netview';
import { NavigationService } from 'netview';
import { DeviceFilterService } from 'netview';
import { DeviceGroupWebService } from 'netview';
import { IpMacFinderResultDialogComponent } from 'netview';
import { PrepareNetworkTransferDialogComponent } from 'netview';

import { InfoSetsComponent } from 'infosets';
import { InfoViewerComponent } from 'infosets';
import { DeviceDetailsComponent } from 'infosets';
import { ConfigInfoViewerComponent } from 'infosets';
import { NotesInfoViewerComponent } from 'infosets';
import { AdminReportsComponent } from 'infosets';
import { ReportsComponent } from 'infosets';
import { ReportViewerComponent } from 'infosets';
import { DiffFileComponent } from 'infosets';
import { DiffViewerComponent } from 'infosets';

import { EventsComponent } from './events';
import { EventsWebService } from './events';
import { EventsService } from './events';

import { MonitorsComponent } from 'monitor';
import { MonitorDeviceSelectorComponent } from 'monitor';
import { MonitorScheduleComponent } from 'monitor';
import { MonitorEventsComponent } from 'monitor';
import { MonitorHistoryComponent } from 'monitor';
import { PingMonitorComponent } from 'monitor';
import { PingSettingsComponent } from 'monitor';
import { PingDevicesComponent } from 'monitor';
import { PingEntryComponent } from 'monitor';
import { PingStateComponent } from 'monitor';
import { PingHistoryComponent } from 'monitor';
import { PingHistoryDialogComponent } from 'monitor';
import { DeviceStateComponent } from 'monitor';
import { SnmpIfMonitorComponent } from 'monitor';
import { SnmpIfSettingsComponent } from 'monitor';
import { SnmpIfDevicesComponent } from 'monitor';
import { SnmpIfSelectorComponent } from 'monitor';
import { SnmpIfStateComponent } from 'monitor';
import { SnmpIfHistoryComponent } from 'monitor';
import { SnmpIfHistoryDialogComponent } from 'monitor';
import { ConfigMonitorComponent } from 'monitor';
import { ConfigSettingsComponent } from 'monitor';
import { ConfigDevicesComponent } from 'monitor';
import { ConfigStateComponent } from 'monitor';
import { ConfigHistoryComponent } from 'monitor';
import { ConfigHistoryDialogComponent } from 'monitor';
import { ConfigTftpSettingsComponent } from 'monitor';
import { CustomSnmpEntryComponent } from 'monitor';
import { CustomSnmpSettingsComponent } from 'monitor';
import { CustomSnmpMonitorComponent } from 'monitor';
import { CustomSnmpDevicesComponent } from 'monitor';
import { CustomSnmpStateComponent } from 'monitor';
import { CustomSnmpHistoryComponent } from 'monitor';
import { CustomSnmpHistoryDialogComponent } from 'monitor';
import { PrtgHistoryComponent } from 'monitor';
import { PrtgHistoryDialogComponent } from 'monitor';
import { MonitorWebService } from 'monitor';
import { MonitorService } from 'monitor';

import { Layer2MapComponent } from 'topomap';
import { DeviceLayer2MapComponent } from 'topomap';
import { LinkDetailsComponent } from 'topomap';
import { PenPatternViewerComponent } from 'topomap';
import { PenPatternSelectorComponent } from 'topomap';
import { PenPatternEditorComponent } from 'topomap';
import { MapExportComponent } from 'topomap';
import { ExportToPrtgDataOnlyComponent } from 'topomap';
import { ExportToPrtgComponent } from 'topomap';
import { ExportToPrtgMapComponent } from 'topomap';
import { PrtgGroupPickerComponent } from 'topomap';
import { PrtgMapPickerComponent } from 'topomap';
import { LayoutSettingsComponent } from 'topomap';
import { LayoutSettingsDialogComponent } from 'topomap';
import { MapSearchComponent } from 'topomap';
import { MapConversionService } from 'topomap';

import { IntegrationSettingsComponent } from 'configuration';
import { AuditLogComponent } from 'configuration';
import { DeviceFiltersComponent } from 'configuration';
import { ITGlueDefaultSettingsComponent } from 'configuration';
import { HaloDefaultSettingsComponent } from 'configuration';
import { HuduDefaultSettingsComponent } from 'configuration';
import { AssetPandaDefaultSettingsComponent } from 'configuration';
import { JiraDefaultSettingsComponent } from 'configuration';
import { ServiceNowDefaultSettingsComponent } from 'configuration';
import { NinjaOneDefaultSettingsComponent } from 'configuration';
import { LucidchartDefaultSettingsComponent } from 'configuration';
import { SlackDefaultSettingsComponent } from 'configuration';
import { AuditLogTableComponent } from 'configuration';
import { DeviceGroupsComponent } from 'configuration';
import { EmailSettingsComponent } from 'configuration';
import { SlackSettingsComponent } from 'configuration';
import { MapDrawSettingsComponent } from 'configuration';
import { ProtocolSettingsComponent } from 'configuration';
import { PatchManagerSettingsComponent } from 'configuration';
import { LinkedServersComponent } from 'configuration';
import { ServerSettingsComponent } from 'configuration';
import { ConfigurationService } from 'configuration';
import { ConfigurationWebService } from 'configuration';

import { ConfigurationComponent } from 'main';
import { NavMenuComponent } from 'main';
import { NavTreeComponent } from 'main';
import { BreadcrumbComponent } from 'main';
import { DeviceSearchComponent } from 'main';

import { ShareSourceComponent } from 'share';
import { ShareSourceDialogComponent } from 'share';
import { ShareTargetComponent } from 'share';
import { ShareTargetDialogComponent } from 'share';
import { ShareManagerComponent } from 'share';
import { ShareEditorComponent } from 'share';
import { SharePrivilegesEditorComponent } from 'share';
import { ShareTypeInfoComponent } from 'share';
import { ShareWebService } from 'share';
import { ShareService } from 'share';
import { HttpSettings } from './DiscoveryEngine.TS/Protocols';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ActivateGuard } from 'netview';

import { ToolsComponent } from 'tools';
import { PortPoeStatusEditorComponent } from 'tools';
import { PortPoeStatusDialogComponent } from 'tools';
import { PortPoeStatusComponent } from 'tools';
import { PortEnableDisableEditorComponent } from 'tools';
import { PortEnableDisableDialogComponent } from 'tools';
import { PortEnableDisableComponent } from 'tools';
import { SinglePortEnableDisableEditorComponent } from 'tools';
import { SinglePortEnableDisableDialogComponent } from 'tools';
import { SinglePortAliasEditorComponent } from 'tools';
import { SinglePortAliasDialogComponent } from 'tools';
import { InterfaceSelectorComponent } from 'tools';
import { PortAccessVlanEditorComponent } from 'tools';
import { PortAccessVlanDialogComponent } from 'tools';
import { PortAccessVlanComponent } from 'tools';
import { BridgePortSelectorComponent } from 'tools';
import { CopyCredentialsComponent } from 'tools';
import { JackToSwitchLookupComponent } from 'tools';
import { SwitchToJackLookupEditorComponent } from 'tools'
import { SwitchToJackLookupDialogComponent } from 'tools'
import { SwitchToJackLookupComponent } from 'tools'
import { Layer2TraceComponent } from 'tools';
import { FindHostComponent } from 'tools';
import { RoomJacksLookupComponent } from 'tools';
import { ToolsWebService } from 'tools';
import { ToolsService } from 'tools';
import { PaginatorModule } from 'primeng/paginator';

import { OffcanvasComponent } from 'widget';
import { UvScrollerModule } from 'widget';
import { UvTableModule } from 'widget';
import { UvxTableComponent } from 'widget';
import { TableVirtualScrollDemoComponent } from 'widget';
import { CarService } from 'widget';

import { TopoMapConfigurationService } from 'configuration/services/topo-map-configuration.service';
import { TopoMapConfigurationWebService } from 'configuration/services/topo-map-configuration.web.service';

/* Angular Material */
import { MatTableModule } from '@angular/material/table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { UserSettingsService } from 'main/services/user-settings.service';
import { ThemeEditorComponent } from 'identity/components/account-editor/theme-editor/theme-editor.component';
import { PrtgMonitorComponent } from 'monitor/components/prtg/prtgmonitor/prtgmonitor.component';
import { PrtgSettings2Component } from 'monitor/components/prtg/prtgsettings2/prtgsettings2.component';

@NgModule({
    declarations: [
        // app
        AppComponent,
        // base
        MessageComponent,
        InfoComponent,
        DeviceCategorySelectorComponent,
        StringSelectorComponent,
        ConfirmationDialogComponent,
        ScheduleComponent,
        // credentials
        CredentialsComponent,
        PrtgSettingsComponent,
        SnmpSettingsComponent,
        SnmpV3SettingsComponent,
        SshSettingsComponent,
        TelnetSettingsComponent,
        VimSettingsComponent,
        WindowsSettingsComponent,
        HttpSettingsComponent,
        // identity
        ProfileComponent,
        AccountComponent,
        AccountEditorComponent,
        PasswordDialogComponent,
        UserListComponent,
        UserComponent,
        UserDialogComponent,
        DirectoryUserComponent,
        DirectoryUserDialogComponent,
        ApiKeyListComponent,
        ApiKeyComponent,
        ApiKeyDialogComponent,
        ActivationWizardComponent,
        DeactivationWizardComponent,
        UpdateLicenseWizardComponent,
        LicenseManagerComponent,
        LoginComponent,
        AuthSettingsComponent,
        AdAuthSettingsComponent,
        AdAdminDialogComponent,
        GwAuthSettingsComponent,
        SamlAuthSettingsComponent,
        GoogleAdminDialogComponent,
        PrivacyPolicyComponent,
        GroupListComponent,
        GroupComponent,
        GroupDialogComponent,
        UserSelectorComponent,
        GroupSelectorComponent,
        DirectoryGroupComponent,
        DirectoryGroupDialogComponent,
        AdminComponent,
        UserTypeInfoComponent,
        // discovery
        SchedDiscConfigAdvancedComponent,
        SchedDiscConfigBasicComponent,
        SchedDiscConfigEventsComponent,
        SchedDiscConfigProtocolsComponent,
        SchedDiscConfigPrtgComponent,
        SchedDiscConfigAssetPandaComponent,
        SchedDiscConfigITGlueComponent,
        SchedDiscConfigHaloComponent,
        SchedDiscConfigHuduComponent,
        SchedDiscConfigJiraComponent,
        SchedDiscConfigScheduleComponent,
        SchedDiscConfigScopesComponent,
        SchedDiscStatusComponent,
        PrtgExportConfigComponent,
        AssetPandaExportConfigComponent,
        ITGlueExportConfigComponent,
        HaloExportConfigComponent,
        HuduExportConfigComponent,
        JiraExportConfigComponent,
        // infosets
        InfoSetsComponent,
        DeviceDetailsComponent,
        InfoViewerComponent,
        ConfigInfoViewerComponent,
        NotesInfoViewerComponent,
        ReportsComponent,
        ReportViewerComponent,
        DiffFileComponent,
        DiffViewerComponent,
        AdminReportsComponent,
        // events
        EventsComponent,
        // topomap
        Layer2MapComponent,
        DeviceLayer2MapComponent,
        LinkDetailsComponent,
        PenPatternViewerComponent,
        PenPatternSelectorComponent,
        PenPatternEditorComponent,
        MapExportComponent,
        ExportToPrtgDataOnlyComponent,
        ExportToPrtgComponent,
        ExportToPrtgMapComponent,
        PrtgGroupPickerComponent,
        PrtgMapPickerComponent,
        LayoutSettingsDialogComponent,
        LayoutSettingsComponent,
        MapSearchComponent,
        // configuration
        AuditLogComponent,
        AuditLogTableComponent,
        DeviceFiltersComponent,
        DeviceGroupsComponent,
        EmailSettingsComponent,
        IntegrationSettingsComponent,
        ITGlueDefaultSettingsComponent,
        HaloDefaultSettingsComponent,
        HuduDefaultSettingsComponent,
        AssetPandaDefaultSettingsComponent,
        JiraDefaultSettingsComponent,
        ServiceNowDefaultSettingsComponent,
        NinjaOneDefaultSettingsComponent,
        LucidchartDefaultSettingsComponent,
        SlackDefaultSettingsComponent,
        SlackSettingsComponent,
        MapDrawSettingsComponent,
        ProtocolSettingsComponent,
        PatchManagerSettingsComponent,
        LinkedServersComponent,
        ServerSettingsComponent,
        // monitor
        MonitorsComponent,
        MonitorDeviceSelectorComponent,
        MonitorScheduleComponent,
        MonitorEventsComponent,
        MonitorHistoryComponent,
        PingMonitorComponent,
        PingSettingsComponent,
        PingDevicesComponent,
        PingEntryComponent,
        PingStateComponent,
        PingHistoryComponent,
        PingHistoryDialogComponent,
        DeviceStateComponent,
        SnmpIfMonitorComponent,
        SnmpIfSettingsComponent,
        SnmpIfDevicesComponent,
        SnmpIfSelectorComponent,
        SnmpIfStateComponent,
        SnmpIfHistoryComponent,
        SnmpIfHistoryDialogComponent,
        ConfigMonitorComponent,
        ConfigSettingsComponent,
        ConfigDevicesComponent,
        ConfigStateComponent,
        ConfigHistoryComponent,
        ConfigHistoryDialogComponent,
        ConfigTftpSettingsComponent,
        CustomSnmpEntryComponent,
        CustomSnmpSettingsComponent,
        CustomSnmpMonitorComponent,
        CustomSnmpDevicesComponent,
        CustomSnmpStateComponent,
        CustomSnmpHistoryComponent,
        CustomSnmpHistoryDialogComponent,
        PrtgSettings2Component,
        PrtgMonitorComponent,
        PrtgHistoryComponent,
        PrtgHistoryDialogComponent,
        // netview
        NetworkComponent,
        NetworkListComponent,
        AgentComponent,
        AgentListComponent,
        DiscoveryComponent,
        DiscoveryListComponent,
        DiscResultComponent,
        DiscResultListComponent,
        NetworkSettingsComponent,
        AgentSettingsComponent,
        DeviceFilterComponent,
        DeviceFilterListComponent,
        DeviceFilterSelectorComponent,
        DeviceGroupComponent,
        DeviceGroupEditorComponent,
        DeviceGroupListComponent,
        NewAgentDialogComponent,
        NewNetworkDialogComponent,
        NewDiscoveryDialogComponent,
        NewUserLinkDialogComponent,
        DeviceGroupDialogComponent,
        UserLinkListComponent,
        MapSettingsComponent,
        DevicesComponent,
        DeviceListComponent,
        DevicePreviewComponent,
        DeviceSelectorComponent,
        NvtnPrtgExportConfigComponent,
        AgentClientComponent,
        IpMacFinderResultDialogComponent,
        PrepareNetworkTransferDialogComponent,
        TableVirtualScrollDemoComponent,
        // main
        ConfigurationComponent,
        NavMenuComponent,
        NavTreeComponent,
        BreadcrumbComponent,
        DeviceSearchComponent,
        ThemeEditorComponent,
        // share
        ShareSourceComponent,
        ShareSourceDialogComponent,
        ShareTargetComponent,
        ShareTargetDialogComponent,
        ShareManagerComponent,
        ShareEditorComponent,
        SharePrivilegesEditorComponent,
        ShareTypeInfoComponent,
        // tools
        ToolsComponent,
        PortPoeStatusEditorComponent,
        PortPoeStatusDialogComponent,
        PortPoeStatusComponent,
        PortEnableDisableEditorComponent,
        PortEnableDisableDialogComponent,
        PortEnableDisableComponent,
        SinglePortEnableDisableEditorComponent,
        SinglePortEnableDisableDialogComponent,
        SinglePortAliasEditorComponent,
        SinglePortAliasDialogComponent,
        InterfaceSelectorComponent,
        PortAccessVlanEditorComponent,
        PortAccessVlanDialogComponent,
        PortAccessVlanComponent,
        BridgePortSelectorComponent,
        CopyCredentialsComponent,
        JackToSwitchLookupComponent,
        SwitchToJackLookupEditorComponent,
        SwitchToJackLookupDialogComponent,
        SwitchToJackLookupComponent,
        Layer2TraceComponent,
        FindHostComponent,
        RoomJacksLookupComponent,
        // widget 
        OffcanvasComponent,
        UvxTableComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        //BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        BrowserModule,
        CommonModule,
        FormsModule,
        BrowserAnimationsModule,
        PaginatorModule,
        RouterModule.forRoot([
            {
                path: 'login',
                component: LoginComponent,
            },
            {
                path: 'admin',
                component: AdminComponent,
                //canActivate: [ActivateGuard],
            },
            //{
            //    path: 'tools',
            //    component: ToolsComponent,
            //    //canActivate: [ActivateGuard],
            //},
            {
                path: 'account',
                component: AccountComponent,
                //canActivate: [ActivateGuard],
            },
            {
                path: 'network/:id',
                component: NetworkComponent,
                //canActivate: [ActivateGuard],
                canDeactivate: [NetworkDeactivateGuard],
            },
            {
                path: 'agent/:id',
                component: AgentComponent,
                //canActivate: [ActivateGuard],
                canDeactivate: [AgentDeactivateGuard],
            },
            {
                path: 'discovery/:id',
                component: DiscoveryComponent,
                //canActivate: [ActivateGuard],
                canDeactivate: [DiscoveryDeactivateGuard],
            },
            {
                path: 'discresult/:id',
                component: DiscResultComponent,
                //canActivate: [ActivateGuard],
            },
            {
                path: 'networks',
                component: ConfigurationComponent,
                //canActivate: [ActivateGuard],
            },
            {
                path: '**',
                component: ConfigurationComponent,
                //canActivate: [ActivateGuard],
            }
        ]),
        RouterModule,
        ReactiveFormsModule,
        AccordionModule,
        TabViewModule,
        TriStateCheckboxModule,
        TableModule,
        MenuModule,
        ContextMenuModule,
        DialogModule,
        ButtonModule,
        CalendarModule,
        MultiSelectModule,
        TreeModule,
        BreadcrumbModule,
        InputTextModule,
        InputNumberModule,
        ListboxModule,
        MenubarModule,
        ToastModule,
        MessagesModule,
        MessageModule,
        ProgressSpinnerModule,
        OverlayPanelModule,
        ColorPickerModule,
        DropdownModule,
        ScrollPanelModule,
        CheckboxModule,
        RadioButtonModule,
        TooltipModule,
        SharedModule,
        NgbModule,
        SplitButtonModule,
        MatTableModule,
        MatSlideToggleModule,
        UvScrollerModule,
        UvTableModule
    ],
    providers: [
        // Angular
        DatePipe,
        // core
        AppConfig,
        { provide: APP_INITIALIZER, useFactory: (config: AppConfig) => () => config.load(), deps: [AppConfig], multi: true },
        HttpClient,
        // base
        MessageService,
        DateService,
        UserSettingsService,
        // discovery
        DiscResultsWebService,
        DiscResultsService,
        // netview
        NetViewWebService,
        NetViewService,
        NetFacadeService,
        NavigationService,
        DeviceGroupWebService,
        DeviceFilterService,
        CarService,
        // identity
        IdentityService,
        UserPermissionsService,
        LicensingService,
        LicensingWebService,
        UsersWebService,
        UsersService,
        ApiKeysWebService,
        ApiKeysService,
        // events
        EventsWebService,
        EventsService,
        // monitor
        MonitorWebService,
        MonitorService,
        // topomap
        MapConversionService,
        // configuration
        ConfigurationService,
        ConfigurationWebService,
        TopoMapConfigurationService,
        TopoMapConfigurationWebService,
        // netview
        ActivateGuard,
        NetworkDeactivateGuard,
        AgentDeactivateGuard,
        DiscoveryDeactivateGuard,
        // share
        ShareWebService,
        ShareService,
        // tools
        ToolsService,
        ToolsWebService,
        HttpSettings,
        PrimeMessageService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {
}
